import { loginIdSchema, passwordSchema } from 'schema/validator'
import z from 'zod'

export type FormValues = z.infer<typeof LoginSchema>
export const LoginSchema = z.object({
  loginId: loginIdSchema,
  password: passwordSchema
})
